// Bons de production (cuisine / bar / jeux) — miroir de backend/routers/invoices.py
export const PRODUCTION_DEPTS = {
  cuisine: ["salle_jardin", "accompagnements"],
  bar: ["bar"],
  jeux: ["jeux"],
};
export const PRODUCTION_LABELS = { cuisine: "Cuisine", bar: "Bar", jeux: "Jeux / Coach" };

export const requiredProductionBons = (items = []) => {
  const depts = new Set(items.map((it) => it.department || ""));
  return Object.keys(PRODUCTION_DEPTS).filter((k) => PRODUCTION_DEPTS[k].some((d) => depts.has(d)));
};

export const missingProductionBons = (invoice) => {
  const printed = invoice?.production_bons || {};
  return requiredProductionBons(invoice?.items).filter((d) => !printed[d]);
};
